import React from "react";
import { Range, getTrackBackground } from "react-range";
import { array, func, object, number } from "prop-types";

import "./range-view.m.css";

const STEP = 1;

const RangeView = ({ min, max, values, onChange }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap"
      }}
    >
      <Range
        values={values}
        step={STEP}
        min={min}
        max={max}
        onChange={values => {
          onChange(values);
        }}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: "36px",
              display: "flex",
              width: "100%"
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: "5px",
                width: "100%",
                borderRadius: "4px",
                margin: "0 32px",
                background: getTrackBackground({
                  values: values,
                  colors: ["#a2a2a2", "#ba0406", "#a2a2a2"],
                  min: min,
                  max: max
                }),
                alignSelf: "center"
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            style={{
              ...props.style,
              height: "24px",
              width: "36px",
              borderRadius: "4px",
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 2px 6px #a2a2a2",
              margin: "0 32px"
            }}
          >
            <div
              style={{
                height: "8px",
                width: "2px",
                marginRight: "1px",
                backgroundColor: isDragged ? "#ba0406" : "#dddddd"
              }}
            />
            <div
              style={{
                height: "8px",
                width: "2px",
                marginLeft: "1px",
                backgroundColor: isDragged ? "#ba0406" : "#dddddd"
              }}
            />
          </div>
        )}
      />
    </div>
  );
};

RangeView.propTypes = {
  values: array,
  onChange: func,
  onMouseDown: func,
  onTouchStart: func,
  style: object,
  ref: object,
  min: number,
  max: number
};

export default RangeView;
